import { UnifiedSelect, SelectItem } from "@cmp-src/form/UnifiedSelect";
import { IOfficesSchedulesIndexed, IResource } from "@gettactic/api";
import { DASHBOARD_TEXTS } from "@/lib/utils-dashboard";

export type FormatOptionLabelProps = {
  type: string;
  value: string;
  label: string;
  name: string;
};

type FilterByUserAndResourceProps = {
  schedules: IOfficesSchedulesIndexed;
  onChange: (query: FormatOptionLabelProps[]) => void;
};

export function FilterByUserAndResource(props: FilterByUserAndResourceProps) {
  const { schedules, onChange } = props;

  const users = Object.keys(schedules.users).map((key) => ({
    type: "user",
    value: schedules.users[key].id,
    label: `${schedules.users[key].name} (${schedules.users[key].email})`,
    name: schedules.users[key].name
  }));

  const resourcesById: Record<string, IResource> = {};

  schedules.elements.forEach((element) => {
    resourcesById[element.resource.id] = element.resource;
  });

  const resources = Object.keys(resourcesById).map((key) => ({
    type: "resource",
    value: resourcesById[key].id,
    label: resourcesById[key].name,
    name: resourcesById[key].name
  }));

  const userItems: SelectItem<FormatOptionLabelProps>[] = users.map((u) => ({
    id: u.value,
    name: u.name,
    data: u
  }));

  const resourceItems: SelectItem<FormatOptionLabelProps>[] = resources.map(
    (r) => ({
      id: r.value,
      name: r.name,
      data: r
    })
  );

  // Use hierarchical items with sections as parent items
  const items: SelectItem<FormatOptionLabelProps>[] = [
    {
      id: "users-section",
      name: DASHBOARD_TEXTS.filterByUserAndResource.labelUser,
      children: userItems
    },
    {
      id: "resources-section",
      name: DASHBOARD_TEXTS.filterByUserAndResource.labelResource,
      children: resourceItems
    }
  ];

  return (
    <UnifiedSelect
      items={items}
      values={[]}
      multiselect
      hierarchical
      searchable
      onSelectMultiple={(selected) => {
        const formattedItems = selected
          .map((item) => item.data)
          .filter((d): d is FormatOptionLabelProps => !!d);
        onChange(formattedItems);
      }}
      placeholder={DASHBOARD_TEXTS.filterByUserAndResource.placeholder}
      triggerClassName="w-full rounded-md border-neutral-300"
    />
  );
}
